import React from 'react';
import { IconContext } from 'react-icons/lib';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  AlertIcon,
  PricingCardAlert,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature,
  Img,
  PricingCardObj,
} from './Pricing.elements';
import { PLANS } from '../constants/plans';

const starterPlan = PLANS.find((plan) => plan.id === 'starter');

function Pricing() {
  return (
    <>
      <div id="precio-pos-restaurante" />
      <IconContext.Provider value={{ color: '#a9b3c1', size: 64 }}>
        <PricingSection>
          <PricingWrapper>
            <PricingHeading>Planes</PricingHeading>

            <PricingContainer>
              <PricingCard style={{ position: 'relative' }}>
                {/* Badge "Por tiempo limitado" */}
                <div style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  background: 'linear-gradient(90deg, #1410DF 0%, #CC11D2 100%)',
                  color: 'white',
                  padding: '5px 14px',
                  borderRadius: '20px',
                  fontSize: '11px',
                  fontWeight: '800',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  boxShadow: '0 2px 8px rgba(20,16,223,0.3)',
                }}>
                  🔥 Por tiempo limitado
                </div>

                <PricingCardInfo>
                  <PricingCardIcon>
                    <Img src={starterPlan.icon} alt="Kusina Plan Starter" />
                  </PricingCardIcon>
                  <PricingCardPlan>{starterPlan.plan}</PricingCardPlan>
                  <PricingCardCost>S/. 0.00</PricingCardCost>
                  <PricingCardLength>gratis mientras seamos nuevos en tu zona</PricingCardLength>
                  <PricingCardObj>{starterPlan.description}</PricingCardObj>
                  <PricingCardAlert>
                    <AlertIcon color="black" /> &nbsp; {starterPlan.alert}
                  </PricingCardAlert>
                  <hr style={{ color: '#DEDEDE', width: 250 }} />
                  <PricingCardFeatures>
                    {starterPlan.features.map((feature, index) => (
                      <PricingCardFeature key={index}>{feature}</PricingCardFeature>
                    ))}
                  </PricingCardFeatures>
                </PricingCardInfo>
              </PricingCard>
            </PricingContainer>
          </PricingWrapper>
        </PricingSection>
      </IconContext.Provider>
    </>
  );
}

export default Pricing;